import { API } from "api/axios.config";
import { createApplicationService } from "./base/applicationServiceBase";

const CONTACT_CATEGORIES_BASE = "/ContactCategories";

const getContactCategoriesAPI = () =>
  API.get(`/contactcategories?orderby=categoryName`);

const addContactCategoryAPI = (data) => API.post(`${CONTACT_CATEGORIES_BASE}`, data);

const updateContactCategoryAPI = (id, data) =>
  API.patch(`${CONTACT_CATEGORIES_BASE}/${id}`, data);

const baseService = createApplicationService({
  name: "contactCategories",
  apiFetchFn: getContactCategoriesAPI,
  apiAddFn: addContactCategoryAPI,
  apiUpdateFn: updateContactCategoryAPI,
});

const contactCategoriesReducer = baseService.reducer;
const getContactCategories = baseService.getData;
const addContactCategory = baseService.addData;
const updateContactCategory = baseService.updateData;
const useContactCategories = baseService.useData;

export {
  contactCategoriesReducer,
  getContactCategories,
  addContactCategory,
  updateContactCategory,
  useContactCategories,
};
